module.exports = __webpack_public_path__ + "static/media/__Real-Estate.0170975b.svg";